import displayError from '@/api/errors/errorResponse'
import { generateRandomFormInputService } from '@/api/services/advertisements/advertisementsService'
import { Button } from '@/components/ui/common/Button'
import { useMutation } from '@tanstack/react-query'
import { UseFormSetValue } from 'react-hook-form'
import { FormSchema } from './generatorFormSchema'

function AutoRandomInput({ setValue }: { setValue: UseFormSetValue<FormSchema> }) {
  const { mutate, isPending } = useMutation({
    mutationFn: () => generateRandomFormInputService(),
    onSuccess: (res) => {
      if (!res.success) return displayError(res)
      setValue('price', res.data.price)
      setValue('priceLast30Days', res.data.priceLast30Days)
      setValue('adSlogan', res.data.adSlogan)
      setValue('productName', res.data.productName)
    }
  })

  const onSubmit = () => {
    mutate()
  }

  return (
    <Button disabled={isPending} onClick={onSubmit} type="button">
      Importuj dane produktu
    </Button>
  )
}

export default AutoRandomInput
